import * as Yup from "yup";

import { Dispatch, bindActionCreators } from "redux";
import React, { Fragment, useEffect, useState } from "react";
import { currencyConfigMoney, maskCPF } from "../../utils";

import AdesaoActions from "../../store/ducks/adesao";
import Button from "../../components/Button";
import Error from "../../components/ErrorLabel";
import IntlCurrencyInput from "react-intl-currency-input";
import MaskedInput from "react-text-mask";
import MenuAside from "../../components/MenuAside";
import Progresso from "../../components/Progresso";
import { RootState } from "../../store/ducks";
import Titulo from "../../components/Titulo";
import Tooltip from "react-tooltip-lite";
import { connect } from "react-redux";
import { nextStepB } from "../../services/navigation";
import translate from "../../i18n";
import { useFormik } from "formik";

interface Props {
  nextStep?: Function;
  previousStep?: Function;
  associadoEspecialRequest?: Function;
  salvarParticipante?: Function;
  verificaInscricaoInstituidorRequest?: Function;
  adesao?: {
    registros: {
      associadoEspecial: {
        instituidor: [
          {
            descPatrocinador: string;
            cnpj: string;
            codPatrocinador: number;
            indPatrocinadorInstituidor: string;
          }
        ];
        plano: [
          {
            descCompleta: string;
            descTipoPlano: string;
            codTipoPlano: number;
            idTipoPlano: number;
          }
        ];
        valorMinimoContribuicao: number;
      };
    };
    error: {
      error: string;
      errorCpfParenteParticiapente: string;
    };
  };
}

const AssociadoEspecial: React.FC<Props> = ({
  nextStep,
  previousStep,
  associadoEspecialRequest,
  adesao,
  salvarParticipante,
  verificaInscricaoInstituidorRequest,
}) => {
  const [
    containerSwitchReajusteHoverEnabled,
    setContainerSwitchReajusteHoverEnabled,
  ] = useState(false);

  const [containerSocialNameHoverEnabled, setContainerSocialNameHoverEnabled] =
    useState(false);

  useEffect(() => {
    associadoEspecialRequest!();
  }, [associadoEspecialRequest]);

  const formik = useFormik({
    initialValues: {
      associadoEspecial: {
        cpf: "",
        nome: "",
        nomeSocial: "",
      },
      dados: {
        instituidor: "",
        plano: "",
        valorContribuicao: "",
        reajusteAutomaticoContribuicao: true,
      },
    },

    validationSchema: Yup.object({
      associadoEspecial: Yup.object({
        nome: Yup.string().required(
          translate.t("app.mensagem.validacaoSeuNome")
        ),
        cpf: Yup.string().required(translate.t("app.mensagem.validacaoSeuCpf")),
      }),
      dados: Yup.object({
        valorContribuicao: Yup.string().required(
          translate.t("app.mensagem.validacaoValorContribuicao")
        ),
        plano: Yup.string().required(
          translate.t("app.mensagem.validacaoPlano")
        ),
        instituidor: Yup.number().required(
          translate.t("app.mensagem.validacaoInstituidor")
        ),
      }),
    }),
    onSubmit: (values) => {
      if (adesao?.registros?.associadoEspecial?.valorMinimoContribuicao) {
        if (
          adesao?.registros?.associadoEspecial?.valorMinimoContribuicao >
          parseFloat(
            values.dados.valorContribuicao
              .replace("R$", "")
              .replace(" ", "")
              .replace(".", "")
              .replace(".", "")
              .replace(",", ".")
              .trimLeft()
          )
        ) {
          formik.setFieldError(
            "dados.valorContribuicao",
            translate.t("app.mensagem.validacaoValorMenorPermitido") +
              " " +
              adesao?.registros?.associadoEspecial?.valorMinimoContribuicao
                .toString()
                .replace(".", ",")
          );
        } else {
          salvarParticipante!({
            dadosCadastrais: {
              pessoa: {
                rg: {
                  numero: "",
                  orgaoExpedidor: "",
                  uf: "",
                  dataExpedicao: "",
                },
                cnh: {
                  numero: "",
                  orgaoExpedidor: "",
                  uf: "",
                  dataExpedicao: "",
                },
                email: "",
                telefone: "",
                celular: "",
                nacionalidade: "",
                estadoCivil: "",
                sexo: "",
                dataNascimento: "",
                nomeFiliacao1: "",
                nomeFiliacao2: "",
              },
            },
            dadosCadastraisEndereco: {
              endereco: {
                idLogredouro: "",
                descLogradouro: "",
                descBairro: "",
                descCidade: "",
                descUf: "",
                numero: "",
                complemento: "",
                cep: "",
              },
            },
          });
          salvarParticipante!({
            dadosAdesao: {
              cpf: formik.values.associadoEspecial.cpf
                .replace(".", "")
                .replace(".", "")
                .replace("-", ""),
              nome: formik.values.associadoEspecial.nome,
              nomeSocial: formik.values.associadoEspecial.nomeSocial
                ? formik.values.associadoEspecial.nomeSocial
                : null,
              valorContribuicao: formik.values.dados.valorContribuicao
                .replace("R$", "")
                .replace(" ", "")
                .replace(".", "")
                .replace(".", "")
                .replace(",", ".")
                .trimLeft(),
              idPatrocinador: formik.values.dados.instituidor,
              idTipoPlano: formik.values.dados.plano,
              indcAtualizacaoContribuicaoAnual: formik.values.dados
                .reajusteAutomaticoContribuicao
                ? "S"
                : "N",
            },
          });
          verificaInscricaoInstituidorRequest!({
            cpf: values.associadoEspecial.cpf
              .replace(".", "")
              .replace(".", "")
              .replace("-", ""),
            idTipoPlano: values.dados.plano,
          });
        }
      }
    },
  });

  function handleBlurMoney(event: any, value: any, maskedValue: any) {
    event.preventDefault();
    formik.handleBlur(event);
    formik.setFieldValue("dados.valorContribuicao", maskedValue);
  }

  return (
    <Fragment>
      <div className="content wrapper">
        <MenuAside step={1} />
        <form onSubmit={formik.handleSubmit}>
          <div className="container">
            <h2>{translate.t("app.tela.associadoEspecial.titulo")}</h2>
            <div className="pt-4 pb-4  mb-4">
              <div className="row">
                <div className="col-lg-12">
                  <div className="d-flex align-items-center">
                    <label className="wrap-checkbox">
                      {" "}
                      <strong>
                        {translate.t(
                          "app.tela.associadoEspecial.label.souAssociadoEspecial"
                        )}{" "}
                      </strong>
                      <input type="checkbox" checked={true} />
                      <span className="check"></span>
                    </label>
                  </div>

                  <hr className="generic-line" />
                </div>
              </div>
              <div
                className="row"
                style={{
                  marginTop: "1.2rem",
                }}
              >
                <div className="col-lg-4">
                  <div className="form-group relative">
                    <label>
                      {translate.t("app.tela.associadoEspecial.label.seuCpf")}
                    </label>
                    <MaskedInput
                      placeholder="000.000.000-00"
                      type="text"
                      name="associadoEspecial.cpf"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.associadoEspecial.cpf}
                      className="form-control"
                      mask={maskCPF}
                    />
                    <Error error={formik.errors.associadoEspecial?.cpf} />
                    <Error
                      error={adesao?.error?.errorCpfParenteParticiapente}
                    />
                  </div>
                </div>

                <div className="col-lg-4">
                  <div className="form-group relative">
                    <label>
                      {translate.t("app.tela.associadoEspecial.label.seuNome")}
                    </label>
                    <input
                      type="text"
                      name="associadoEspecial.nome"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.associadoEspecial.nome}
                      className="form-control"
                    />
                    <Error error={formik.errors.associadoEspecial?.nome} />
                  </div>
                </div>
              </div>

              <div
                className="row"
                style={{
                  marginTop: "1.2rem",
                }}
              >
                <div className="col-lg-8">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      border: containerSocialNameHoverEnabled
                        ? "1px solid #17a2b8"
                        : "1px dashed",
                      borderRadius: "5px",
                      paddingRight: "10px",
                    }}
                    className="form-group relative"
                    onMouseEnter={() =>
                      setContainerSocialNameHoverEnabled(true)
                    }
                    onMouseLeave={() =>
                      setContainerSocialNameHoverEnabled(false)
                    }
                  >
                    <label style={{ cursor: "pointer" }}>
                      {translate.t(
                        "app.tela.associadoEspecial.label.seuNomeSocial"
                      )}
                    </label>
                    <input
                      style={{
                        border: "none",
                        outline: "none",
                        boxShadow: "none",
                      }}
                      type="text"
                      name="associadoEspecial.nomeSocial"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.associadoEspecial.nomeSocial}
                      className="form-control"
                    />
                    <div style={{ display: "none" }} />
                    <Tooltip
                      className="ml-2"
                      direction="right"
                      background="black"
                      color="white"
                      content={
                        <>
                          <p>
                            {translate.t(
                              "app.mensagem.informativoNomeSocialParte1"
                            )}
                            <br />
                            {translate.t(
                              "app.mensagem.informativoNomeSocialParte2"
                            )}
                            <br />
                            {translate.t(
                              "app.mensagem.informativoNomeSocialParte3"
                            )}
                            <br />
                            {translate.t(
                              "app.mensagem.informativoNomeSocialParte4"
                            )}
                            <br />
                            {translate.t(
                              "app.mensagem.informativoNomeSocialParte5"
                            )}
                            <br />
                          </p>
                          <i>
                            {translate.t(
                              "app.mensagem.informativoNomeSocialParte6"
                            )}
                            <br />
                            {translate.t(
                              "app.mensagem.informativoNomeSocialParte7"
                            )}
                            <br />
                            {translate.t(
                              "app.mensagem.informativoNomeSocialParte8"
                            )}
                          </i>
                        </>
                      }
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="#17a2b8"
                        viewBox="0 0 24 24"
                        style={{ cursor: "pointer" }}
                      >
                        <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm0 18.25c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25c.691 0 1.25.56 1.25 1.25s-.559 1.25-1.25 1.25zm1.961-5.928c-.904.975-.947 1.514-.935 2.178h-2.005c-.007-1.475.02-2.125 1.431-3.468.573-.544 1.025-.975.962-1.821-.058-.805-.73-1.226-1.365-1.226-.709 0-1.538.527-1.538 2.013h-2.01c0-2.4 1.409-3.95 3.59-3.95 1.036 0 1.942.339 2.55.955.57.578.865 1.372.854 2.298-.016 1.383-.857 2.291-1.534 3.021z"></path>
                      </svg>
                    </Tooltip>
                    <Error
                      error={formik.errors.associadoEspecial?.nomeSocial}
                    />
                  </div>
                </div>
              </div>
              <div
                style={{
                  marginTop: "1.2rem",
                  minHeight: "92px",
                }}
                className="row"
              >
                <div className="col-lg-4">
                  <div className="form-group relative">
                    <label>
                      {translate.t(
                        "app.tela.associadoEspecial.label.instituidor"
                      )}
                    </label>
                    <div>
                      <select
                        name="dados.instituidor"
                        className="form-control"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.dados.instituidor}
                      >
                        {adesao?.registros?.associadoEspecial?.instituidor?.map(
                          (instituidor: any, indice) => {
                            if (indice === 0) {
                              if (formik.values.dados.instituidor === "") {
                                formik.values.dados.instituidor =
                                  instituidor.codPatrocinador;
                              }
                            }
                            return (
                              <option
                                key={instituidor.codPatrocinador}
                                value={instituidor.codPatrocinador}
                              >
                                {instituidor.descPatrocinador}
                              </option>
                            );
                          }
                        )}
                      </select>
                    </div>
                    <Error error={formik.errors.dados?.instituidor} />
                  </div>
                </div>

                <div className="col-lg-4">
                  <div className="form-group relative">
                    <label>
                      {translate.t("app.tela.associadoEspecial.label.plano")}
                    </label>
                    <div>
                      <select
                        name="dados.plano"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.dados.plano}
                        className="form-control"
                      >
                        {adesao?.registros?.associadoEspecial?.plano?.map(
                          (plano: any, indice) => {
                            if (indice === 0) {
                              if (formik.values.dados.plano === "") {
                                formik.values.dados.plano = plano.codTipoPlano;
                              }
                            }
                            return (
                              <option
                                key={plano.codTipoPlano}
                                value={plano.codTipoPlano}
                              >
                                {plano.descCompleta}
                              </option>
                            );
                          }
                        )}
                      </select>
                    </div>
                    <Error error={formik.errors.dados?.plano} />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-4">
                  <div className="form-group relative">
                    <label>
                      {translate.t(
                        "app.tela.associadoEspecial.label.valorContribuicao"
                      )}
                    </label>
                    <IntlCurrencyInput
                      type="text"
                      name="dados.valorContribuicao"
                      onChange={formik.handleChange}
                      onBlur={handleBlurMoney}
                      value={formik.values.dados.valorContribuicao}
                      className="form-control"
                      currency="BRL"
                      config={currencyConfigMoney}
                      maxLength="17"
                    />

                    <Error error={formik.errors.dados?.valorContribuicao} />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      height: "42px",
                      borderRadius: "5px",
                      border: containerSwitchReajusteHoverEnabled
                        ? "1px solid #17a2b8"
                        : "1px dashed",
                      lineHeight: "24px",
                      fontFamily: "Bree Serif",
                      padding: "9px",
                    }}
                    className="form-group relative"
                    onMouseEnter={() =>
                      setContainerSwitchReajusteHoverEnabled(true)
                    }
                    onMouseLeave={() =>
                      setContainerSwitchReajusteHoverEnabled(false)
                    }
                  >
                    <label style={{ cursor: "pointer" }}>
                      {translate.t(
                        "app.tela.associadoEspecial.label.reajusteAutomaticoContribuicao"
                      )}
                    </label>
                    <div
                      style={{
                        display: "none",
                      }}
                    />
                    <div>
                      NÃO
                      <label className="switch">
                        {" "}
                        <input
                          type="checkbox"
                          name="dados.reajusteAutomaticoContribuicao"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          checked={
                            formik.values.dados.reajusteAutomaticoContribuicao
                          }
                        />
                        <span className="slider round"></span>
                      </label>
                      SIM
                    </div>

                    <Tooltip
                      className="ml-2"
                      direction="right"
                      background="black"
                      color="white"
                      content={
                        <>
                          <p>
                            {translate.t(
                              "app.mensagem.reajusteAutomaticoContribuicaoParte1"
                            )}
                            <br />
                            {translate.t(
                              "app.mensagem.reajusteAutomaticoContribuicaoParte2"
                            )}
                            <br />
                            {translate.t(
                              "app.mensagem.reajusteAutomaticoContribuicaoParte3"
                            )}
                            <br />
                            {translate.t(
                              "app.mensagem.reajusteAutomaticoContribuicaoParte4"
                            )}
                            <br />
                            {translate.t(
                              "app.mensagem.reajusteAutomaticoContribuicaoParte5"
                            )}
                            <br />
                            {translate.t(
                              "app.mensagem.reajusteAutomaticoContribuicaoParte6"
                            )}
                            <br />
                            {translate.t(
                              "app.mensagem.reajusteAutomaticoContribuicaoParte7"
                            )}
                          </p>
                        </>
                      }
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="#17a2b8"
                        viewBox="0 0 24 24"
                        style={{ cursor: "pointer" }}
                      >
                        <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm0 18.25c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25c.691 0 1.25.56 1.25 1.25s-.559 1.25-1.25 1.25zm1.961-5.928c-.904.975-.947 1.514-.935 2.178h-2.005c-.007-1.475.02-2.125 1.431-3.468.573-.544 1.025-.975.962-1.821-.058-.805-.73-1.226-1.365-1.226-.709 0-1.538.527-1.538 2.013h-2.01c0-2.4 1.409-3.95 3.59-3.95 1.036 0 1.942.339 2.55.955.57.578.865 1.372.854 2.298-.016 1.383-.857 2.291-1.534 3.021z"></path>
                      </svg>
                    </Tooltip>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4 pt-lg-1 mb-4">
                  <a
                    href="https://s137.fachesf.com.br/SimuladorRealizePrev/"
                    className="btn btn-secondary mt-lg-4"
                    target="blank"
                    style={{
                      backgroundColor: "#17a2b8",
                      borderColor: "#17a2b8",
                    }}
                  >
                    {translate.t("app.botao.simularMinhaAposentadoria")}
                  </a>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-12">
                  <p>
                    <small>
                      <em> {translate.t("app.mensagem.camposObrigatorios")}</em>
                    </small>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="membership__pagination text-center mt-3">
            <Button previousStep={previousStep ? previousStep : () => {}} />

            <Button avancar previousStep={() => {}} />
          </div>
        </form>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state: RootState) => ({
  adesao: state.adesao,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(AdesaoActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AssociadoEspecial);
